import { defineMessages } from 'react-intl'

export default defineMessages({
  loading: {
    id: 'SpaceAppBuilderDetails.Loading',
    defaultMessage: 'Loading...'
  },
  saving: {
    id: 'SpaceAppBuilderDetails.SavingFeature',
    defaultMessage: 'Creating Feature...'
  },
  updating: {
    id: 'SpaceAppBuilderDetails.UpdatingFeature',
    defaultMessage: 'Updating Feature...'
  },
  appBuilder: {
    id: 'SpaceAppBuilderDetails.Title',
    defaultMessage: 'App Builder'
  },
  dataSources: {
    id: 'SpaceAppBuilderDetails.dataSources',
    defaultMessage: 'Data Sources'
  },
  addSourceLink: {
    id: 'SpaceAppBuilderDetails.addSourceLink',
    defaultMessage: 'Add a data source'
  },
  editSource: {
    id: 'SpaceAppBuilderDetails.editSource',
    defaultMessage: 'Edit data source'
  },
  deleteSource: {
    id: 'SpaceAppBuilderDetails.deleteSource',
    defaultMessage: 'Delete data source'
  },
  deleteSourceMessage: {
    id: 'SpaceAppBuilderDetails.deleteSourceMessage',
    defaultMessage: 'Deleting data source'
  },
  failedToDelete: {
    id: 'SpaceAppBuilderDetails.failedToDelete',
    defaultMessage: 'Failed to delete data source'
  },
  confirmDeleteDataSource: {
    id: 'SpaceAppBuilderDataSourcePage.confirmDeleteDataSource',
    defaultMessage: 'Are you sure you want to delete the {dataSource} Data Source?'
  },
  noPermissionNoDataSources: {
    id: 'SpaceAppBuilderDetails.noPermissionNoDataSources',
    defaultMessage: 'No data sources currently available'
  },
  trigger: {
    id: 'SpaceAppBuilderDetails.trigger',
    defaultMessage: 'Trigger'
  },
  type: {
    id: 'SpaceAppBuilderDetails.type',
    defaultMessage: 'Type'
  },
  titleRequiredMessage: {
    id: 'SpaceAppBuilderDetails.Feature.Name',
    defaultMessage: 'Enter a name'
  },
  featureNameMin: {
    id: 'SpaceAppBuilderDetails.Feature.NameMin',
    defaultMessage: 'Name must be at least 2 characters'
  },
  viewLogs: {
    id: 'SpaceAppBuilderDetails.ViewLogs',
    defaultMessage: 'View Logs'
  },
  viewHistory: {
    id: 'SpaceAppBuilderDetails.ViewHistory',
    defaultMessage: 'View History'
  },
  save: {
    id: 'SpaceAppBuilderDetails.save',
    defaultMessage: 'Save'
  },
  continue: {
    id: 'SpaceAppBuilderDetails.continue',
    defaultMessage: 'Continue'
  },
  cancel: {
    id: 'SpaceAppBuilderDetails.Cancel',
    defaultMessage: 'Cancel'
  },
  appUsage: {
    id: 'SpaceAppBuilderDetails.AppUsage',
    defaultMessage: 'App Usage'
  },
  appSettings: {
    id: 'SpaceAppBuilderDetails.AppSettings',
    defaultMessage: 'App Settings'
  },
  appEdit: {
    id: 'SpaceAppBuilderDetails.AppEdit',
    defaultMessage: 'Edit App'
  },
  appDelete: {
    id: 'SpaceAppBuilderDetails.AppDelete',
    defaultMessage: 'Delete App'
  },
  confirmDeleteAppTitle: {
    id: 'SpaceAppBuilderDetails.confirmDeleteAppTitle',
    defaultMessage: 'Delete App?'
  },
  confirmAppDelete: {
    id: 'SpaceAppBuilderDetails.ConfirmDelete',
    defaultMessage: 'Are you sure you want to delete the {appName} application?'
  },
  confirmAgentDelete: {
    id: 'SpaceAppBuilderDetails.ConfirmDelete',
    defaultMessage: 'Are you sure you want to delete the {appName} agent?'
  },
  yesDeleteApp: {
    id: 'SpaceAppBuilderDetails.YesDeleteApp',
    defaultMessage: 'Yes, Delete App'
  },
  confirmDeleteDataSourceTitle: {
    id: 'SpaceAppBuilderDetails.confirmDeleteDataSourceTitle',
    defaultMessage: 'Delete Data Source?'
  },
  yesDeleteDataSource: {
    id: 'SpaceAppBuilderDetails.YesDeleteDataSource',
    defaultMessage: 'Yes, Delete Data Source'
  },
  status: {
    id: 'SpaceAppBuilderDetails.status',
    defaultMessage: 'Status'
  },
  failedAuth: {
    id: 'SpaceAppBuilderDetails.DataSourceWizard.failedAuth',
    defaultMessage: 'Failed to authenticate. Please check your credentials or configuration'
  },
  backToDashboard: {
    id: 'SpaceAppBuilderDetails.BackToDashboard',
    defaultMessage: 'Back to Dashboard'
  },
  exportApp: {
    id: 'SpaceAppBuilderDetails.ExportApp',
    defaultMessage: 'Export App'
  },
  shareApp: {
    id: 'SpaceAppBuilderDetails.shareApp',
    defaultMessage: 'Share App'
  },
  deleteAppInstance: {
    id: 'SpaceAppBuilderDetails.DeleteAppInstance',
    defaultMessage: 'Deleting App Instance'
  },
  updateAppInstance: {
    id: 'SpaceAppBuilderDetails.updateAppInstance',
    defaultMessage: 'Updating App...'
  },
  reauthenticationMessage: {
    id: 'SpaceAppBuilderDataSourcePage.ReauthenticationDataSourceErrorMessage',
    defaultMessage: 'Reauthentication required'
  },
  preview: {
    id: 'SpaceAppBuilderDetails.preview',
    defaultMessage: 'Preview'
  },
  draft: {
    id: 'SpaceAppBuilderDetails.draft',
    defaultMessage: 'Draft.'
  },
  openFeature: {
    id: 'SpaceAppBuilderDetails.openFeature',
    defaultMessage: 'Open'
  }
})
